export const BLUR_CLASS = 'blur'

export const SCROLL_CLASS = 'scroll-fix'

export const DIRECTION_UP_CLASS = 'direction-up'

export const DIRECTION_DOWN_CLASS = 'direction-down'